import { apiClient } from '@/shared/data/client';
import type { DiagnosticsReportDto } from '@flowqa/shared';

type DiagnosticsReportApi = Omit<DiagnosticsReportDto, 'timestamp'> & { timestamp: string | Date };

const mapDiagnosticsReport = (report: DiagnosticsReportApi): DiagnosticsReportDto => ({
  ...report,
  timestamp: report.timestamp instanceof Date ? report.timestamp : new Date(report.timestamp),
});

export const fetchDiagnosticsReport = async (token: string): Promise<DiagnosticsReportDto> => {
  const report = await apiClient.get<DiagnosticsReportApi>('superuser/diagnostics', { token });
  return mapDiagnosticsReport(report);
};
